import * as vp from 'vopay';
import { useClientData } from '../../providers/ClientData.provider';
import UserDropDown from './UserDropDown/UserDropDown';
import { JSX } from 'react';

const { Box, NavTop } = vp;

const DashboardNavTop = (): JSX.Element => {
  const { response } = useClientData();

  return (
    <NavTop>
      <Box jc="fe" ai="center" gap="sm">
        <div>{`${response.AccountName} (${response.AccountID})`}</div>
        <div className="dropdownContainer">
          <UserDropDown />
        </div>
      </Box>
    </NavTop>
  );
};

export default DashboardNavTop;
